/// <reference path="../../PropertyManagement/Tenants/TenantsGrid.ts" />

namespace SorAraBul.PropertyManagement {

    import fld = TenantsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class TenantsListGrid extends TenantsGrid {
        protected getDialogType() { return TenantsListDialog; }
        protected getColumnsKey() { return TenantsColumns.columnsKey; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}